import type { StockResponse } from '../../types/shared';
import RegionCloseCard from './RegionCloseCard';

interface Props {
  /** Used purely to enumerate regions; per-region close data is fetched
   *  independently by each RegionCloseCard. The previous per-warehouse stock
   *  rendering inside StockTable is replaced by the close-status frame. */
  stockData: StockResponse;
  period:    string;
}

export default function StockTable({ stockData, period }: Props) {
  // The legacy `__unassigned__` synthetic group from getStockLevels is not a
  // real region and can't have a close period — exclude it.
  const regions = stockData.regions.filter(r => r.regionId !== '__unassigned__');

  if (regions.length === 0) {
    return (
      <div className="rounded-xl border border-stone-200 dark:border-stone-700 bg-stone-50 dark:bg-[#1e2521] px-4 py-8 text-center text-sm text-stone-500 dark:text-stone-400">
        No regions configured.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {regions.map(r => (
        <RegionCloseCard key={r.regionId} regionId={r.regionId} period={period} />
      ))}
    </div>
  );
}
